import { fetchJSON } from '@eb/http';
import { trackAnalyticsEvent } from '@eb/site-analytics';
import isEmpty from 'lodash/isEmpty';

import { ALL_TAB } from '../../../../constants/tabConfig';

import { buildBBox, getFeedTrackingProperties } from '../../utils';

import { getInitialState } from '../index';
import { fetchEventsForTab } from '../events/actions';
import { fetchCollectionsForPlace } from '../content/actions';
import { getOrganizersUserFollow } from '../organizers/actions';
import {
    setFeCallAsOngoing,
    setFeCallAsSuccess,
    setFeCallAsFailed,
} from '../app/actions';

import { UPDATE_ROOT_CONTEXT } from './rootActionTypes';

import {
    NAV_EXPERIMENT_NEW_HEADER,
    NAV_EXPERIMENT_OLD_HEADER,
} from '../../../../SearchApp/actions/analytics';

function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export const getRestOfContext = (originalContext) => (dispatch) => {
    dispatch(setFeCallAsOngoing());

    fetchJSON('/fe/')
        .then(async (response) => {
            let feResponse = response;

            if (response.flatBucket.__should_suggest_reloading_page) {
                // The homepage backend has a performance optimization where it will always attempt to retrieve
                // events from memcache. If the cache is cold, then it will return __should_suggest_reloading_page to
                // the frontend. If that happens, we want to wait 1000ms and retry one time, hoping that it's
                // enough time to populate the backend cache.
                await sleep(1000);
                feResponse = await fetchJSON('/fe/');
            }

            const filteredResponse = feResponse;

            if (!isEmpty(filteredResponse.buckets)) {
                //we filter out the bucket "liked_events" from the response so we only use the liked_events from the api call
                filteredResponse.buckets = response.buckets.filter(
                    (bucket) => bucket.key !== 'liked_events',
                );
            }

            const fullContext = getInitialState({
                ...originalContext,
                ...filteredResponse,
            });

            if (fullContext.content.browseState.tabKey !== ALL_TAB) {
                fullContext.content.flatBucket = {};
            }

            dispatch({
                type: UPDATE_ROOT_CONTEXT,
                payload: fullContext,
            });

            const {
                content: {
                    flatBucket,
                    browseState: { tabKey },
                },
                location: { placeId, latitude, longitude },
                user: { isAuthenticated, publicId },
                env: { launchNewNavigationHeader },
            } = fullContext;

            // TODO: Move the trackAnalyticsEvent back into ConsumerHeader/index.js after nav experiment is over
            // JIRA clean up ticket: EB-149406
            let experimentId3 = null;
            // Send this dimension along when the user is not authenticated
            if (!isAuthenticated) {
                experimentId3 = launchNewNavigationHeader
                    ? NAV_EXPERIMENT_NEW_HEADER
                    : NAV_EXPERIMENT_OLD_HEADER;
            }

            const feedTrackingProperties = getFeedTrackingProperties(
                isAuthenticated,
                publicId,
                { experimentId3 },
            );

            trackAnalyticsEvent(feedTrackingProperties);

            dispatch(getOrganizersUserFollow());

            // TODO: fix the server to perform a search when the cookie contains a lat/lng.
            // Currently, the server only looks for a place id when deciding whether to supply
            // events in the context for the client.  We work around the problem by issuing
            // an ajax search request.  Once the server is fixed, remove the code below.
            if (isEmpty(flatBucket) && !placeId && latitude && longitude) {
                dispatch(
                    fetchEventsForTab({
                        tabKey,
                        locationData: {
                            bbox: buildBBox({ latitude, longitude }),
                        },
                    }),
                );
            }

            dispatch(setFeCallAsSuccess());
            dispatch(
                fetchCollectionsForPlace(
                    fullContext.content.browseState.tabKey,
                ),
            );
        })
        .catch(() => {
            dispatch(setFeCallAsFailed());
        });
};
